import useSWR from 'swr';
import fetcher from 'lib/fetcher';
import { ISelectItem } from 'lib/types';

export type ITypesBuildingByComplexResponse = {
  id: number;
  fullTitle: string;
}[];

const useTypesBuildingByComplexId = (id?: number | null, isTransformForSelect?: boolean) => {
  const { data, error, isLoading } = useSWR(
    id ? `/building/${id}/project-types` : null,
    (url) => (id ? fetcher.swr<ITypesBuildingByComplexResponse>(url) : null),
    { errorRetryCount: 0, revalidateOnFocus: false },
  );

  const transformData = (
    dataList: ITypesBuildingByComplexResponse | undefined | null,
  ): ISelectItem[] => {
    if (dataList) {
      return dataList.map((item) => ({
        key: item.id,
        label: item.fullTitle,
      }));
    }
    return [];
  };

  return {
    types: isTransformForSelect ? transformData(data) : data ?? [],
    error,
    isLoading,
  };
};

export default useTypesBuildingByComplexId;
